import '../css/style.less';
import Loader from 'my/loader';

document.addEventListener('DOMContentLoaded', function () {
	new Loader();
});